module.exports = __webpack_public_path__ + "static/img/14-01.91730d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/award/14-01.png
// module id = s0F4
// module chunks = 1